
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "UserEditTableTab",
  props: {
    label: { type: String, required: true },
    active: { type: Boolean, required: true },

    onSelect: { type: Function as PropType<() => void>, required: true },
  },
  setup(props) {
    return {
      onSelectInternal: () => {
        if (props.active) return;
        props.onSelect();
      },
    };
  },
});
